import React from "react"
import Layout from "../../../components/layout"
import { Link } from "gatsby"

export default props => (
  <Layout location={props.location}>
    <div className="row">
      <div className="col-md-12">
        <div className="page-header">
          <h1>
            GET /tasks/{"{"}taskId{"}"}/messages
          </h1>
        </div>
        <p>
          Return a JSON object that lists the messages associated with the
          specified task. Note: Use <em>nextPageUrl</em> and{" "}
          <em>prevPageUrl</em> from the response data for query{" "}
          <Link to="/guides/pagination">pagination</Link>.
        </p>
        <h2>URL Parameters</h2>
        <div className="table-responsive">
          <table className="table table-striped table-bordered table-condensed">
            <tbody valign="top">
              <tr>
                <th>Name</th>
                <th>Description</th>
                <th>Location</th>
                <th>Required</th>
                <th>Default Value</th>
              </tr>
              <tr>
                <td>taskId</td>
                <td>Unique identifier for task.</td>
                <td>path</td>
                <td>Yes</td>
                <td />
              </tr>
              <tr>
                <td>size</td>
                <td>The number of responses to return per request</td>
                <td>Query</td>
                <td>No</td>
                <td>30</td>
              </tr>
              <tr>
                <td>pageref</td>
                <td>
                  Readonly. This parameter is not used by Spaces and is only a
                  reference. i.e.: the value sent will be the same value
                  returned.
                </td>
                <td>query</td>
                <td>No</td>
                <td />
              </tr>
              <tr>
                <td>nextRefObjId</td>
                <td>A unique ID used to return the next results page</td>
                <td>Query</td>
                <td>No</td>
                <td />
              </tr>
              <tr>
                <td>prevRefObjId</td>
                <td>A unique ID used to return the previous results page</td>
                <td>Query</td>
                <td>No</td>
                <td />
              </tr>
            </tbody>
          </table>
        </div>
        <h2>Body Parameters</h2>
        <p>None.</p>
        <h2>Authentication</h2>
        <p>JwtAuthenticator, Oauth2Authenticator, AnonymousAuthenticator</p>
        <h2>Authorization</h2>
        <p>PERM_TOPIC_TASK_READ</p>
        <h2>Example Request</h2>
        <h4>URL</h4>
        <pre className="nginx">
          GET https://spacesapis.avayacloud.com/api/tasks/{"{"}taskId{"}"}/messasges
        </pre>
        <h4>Headers</h4>
        <pre className="javascript">
          Authorization: "jwt
          eyJhbGciOiJSUzI1NiIsIdfgdfgnR5cCI6IkpXVCJ9.eyJ1c2VyX2lkX3NpZyI6ImxPWHpxNzVzR3J3X0xwWEMyRGRMakhyYXJlWVhyTzFMdEZHZkhkOWNkTXciLCJwcm9kdWN0X3R5cGUiOiJhY2NvdW50cyIsImxhc3R1cGRhdGV0aW1lIjoiMjAxNy0wMS0zMFQxMzo1ODo0Ny4yMDYiLCJpc3MiOiJ6YW5nLmlvIiwicHVibGlja2V5aWQiOiJhZ3h6Zm05dVpYTnVZVEl3TVRSeUdnc1NEVWRLZDNSUWRXSnNhV05MWlhrdfgdWdJQ2dsUEtFakFvTSIsImV4cCI6MTQ5NTM5MTIwMywidXNlcl9pZCI6ImFneHpmbTl1WlhOdVlUSXdNVFJ5RVFzU0JGVnpaWElZZ0lEQXMtX25fUW9NIiwidmVyIjoiMi4wIn0.SqZpw1uPIebqW3qlDsm0-DWYFKEH0SgPwtD-tSESWOF-5hLkZMqJH28ooWux2S7s9riIew7pTVPnZpTgJa5zHcEAG0gXSEJVOqmpGp_4ufM8YtZoZMpBFjyAkwyAt-ILkGUYIo0GU5WyzMPLV8YLXfgdfgOgkE2MGGOajBkjPmC2Db3pA0D0M9k-21EL1gwWBC5YIq0PDAkgulegwl6khRmB8irJQ-dfg-d-KV9eYfFpsCdJKRGzSfqg"
        </pre>
        <p>Or</p>
        <pre className="javascript">
          Authorization: "bearer f746696f5de4528u128ae2f274eea253e8a7943a"
        </pre>
        <h2>Example Response</h2>
        <pre className="json">
          {"{"}
          {"\n"}
          {"  "}"data": [{"\n"}
          {"    "}
          {"{"}
          {"\n"}
          {"      "}"_id": "5900f95cc284716066e5ea03",{"\n"}
          {"      "}"category": "chat",{"\n"}
          {"      "}"topicId": "58c84f043cd7a650040d0402",{"\n"}
          {"      "}"modified": null,{"\n"}
          {"      "}"content": {"{"}
          {"\n"}
          {"        "}"bodyText": "sdfgsdfg",{"\n"}
          {"        "}"description": "",{"\n"}
          {"        "}"data": []{"\n"}
          {"      "}
          {"}"},{"\n"}
          {"      "}"created": "2017-04-26T19:47:40.373Z",{"\n"}
          {"      "}"sender": {"{"}
          {"\n"}
          {"        "}"_id": "5890b1243bab0e18ff044943",{"\n"}
          {"        "}"type": "user",{"\n"}
          {"        "}"username": "patrickhan@esna.com",{"\n"}
          {"        "}"displayname": "Patrick-123 Han-han",{"\n"}
          {"        "}"picture_url":
          "https://storage.googleapis.com/onesnatesting/pictures/pfpic_user_287f310f-aba5-4879-a18e-247c07c4894a",
          {"\n"}
          {"        "}"gender": "",{"\n"}
          {"        "}"addresses": [],{"\n"}
          {"        "}"phone_numbers": [],{"\n"}
          {"        "}"name": {"{"}
          {"\n"}
          {"          "}"familyname": "Han-han",{"\n"}
          {"          "}"formatted": "",{"\n"}
          {"          "}"givenname": "Patrick-123",{"\n"}
          {"          "}"honorific_prefix": "",{"\n"}
          {"          "}"honorific_suffix": "",{"\n"}
          {"          "}"middlename": "",{"\n"}
          {"          "}"pronunciation": "",{"\n"}
          {"          "}"pronunciation_url": ""{"\n"}
          {"        "}
          {"}"}
          {"\n"}
          {"      "}
          {"}"},{"\n"}
          {"      "}"likeCount": 0,{"\n"}
          {"      "}"chatCount": 0,{"\n"}
          {"      "}"parentMsg": {"{"}
          {"\n"}
          {"        "}"_id": "5900f92ec284716066e5e9fe",{"\n"}
          {"        "}"bodyText": "dfgdf",{"\n"}
          {"        "}"category": "task"{"\n"}
          {"      "}
          {"}"}
          {"\n"}
          {"    "}
          {"}"}
          {"\n"}
          {"  "}],{"\n"}
          {"  "}"nextPageUrl":
          "/api/tasks/5900f92ec284716066e5e9fe/messages?size=1&amp;pageref=2&amp;nextRefObjId=5900f95cc284716066e5ea03",
          {"\n"}
          {"  "}"previousPageUrl": "",{"\n"}
          {"  "}"total": 1{"\n"}
          {"}"}
          {"\n"}
        </pre>
      </div>
    </div>
  </Layout>
)
